import { Col, Form, Modal, ModalBody, ModalFooter, Row } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import React from 'react';
import Swal from 'sweetalert2';
import ExcursionService from '../../repository/tourRepository/ExcursionRepository';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { strings } from '../../localization/Localization';

const AddEditExcursionModal = (props) => {

  const schema = yup.object().shape({
    name: yup.string().required(strings.requiredField),
    placeTo: yup.string().required(strings.requiredField),
    dateFrom: yup.string().required(strings.requiredField),
    dateTo: yup.string().required(strings.requiredField),
    price: yup.string().required(strings.requiredField),
    discount: yup.string().required(strings.requiredField),
    totalSeats: yup.string().required(strings.requiredField),
  });

  const addExcursionSuccessfulAlert = (message) => {
    Swal.fire({
      icon: 'success',
      title: message,
    })
  }

  const errorAlert = (error) => {
    console.error("API Error:", error);
    Swal.fire({
      title: strings.somethingWentWrong,
      text: error?.response?.data?.message || strings.errorOccurred,
      icon: "error",
      dangerMode: true
    });
  }

  const addExcursion = (name, placeTo, dateFrom, dateTo, price, discount, totalSeats) => {
    const bookedSeats = 0;

    ExcursionService.addExcursion(name, placeTo, dateFrom, dateTo, price, discount, totalSeats, bookedSeats)
      .then(() => {
        addExcursionSuccessfulAlert(strings.successfullyAddedExcursion);
        props.getExcursions();
        props.handleClose();
      }).catch((error) => {
      errorAlert(error);
    });
  }

  const updateExcursion = (id, name, placeTo, dateFrom, dateTo, price, discount, totalSeats) => {
    const bookedSeats = props.selectedExcursionForEdit?.bookedSeats || 0;

    ExcursionService.updateExcursion(id, name, placeTo, dateFrom, dateTo, price, discount, totalSeats, bookedSeats)
      .then(() => {
        addExcursionSuccessfulAlert(strings.successfullyUpdatedExcursion);
        props.getExcursions();
        props.handleClose();
      }).catch((error) => {
      errorAlert(error);
    });
  }

  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}/${month}/${year}`;
  }

  const convertToISODate = (date) => {
    if (!date) return '';
    try {
      const [day, month, year] = date.split('/');
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error("Date conversion error:", error);
      return '';
    }
  };

  const onFormSubmit = (values) => {
    const name = values.name.trim();
    const placeTo = values.placeTo.trim();
    const price = values.price;
    const discount = values.discount;
    const totalSeats = values.totalSeats;

    const dateFrom = values.dateFrom ? formatDateToDDMMYYYY(values.dateFrom) : null;
    const dateTo = values.dateTo ? formatDateToDDMMYYYY(values.dateTo) : null;

    if (props.selectedExcursionForEdit?.id) {
      updateExcursion(props.selectedExcursionForEdit.id, name, placeTo, dateFrom, dateTo, price, discount, totalSeats);
    } else {
      addExcursion(name, placeTo, dateFrom, dateTo, price, discount, totalSeats);
    }
  }

  const fields = [
    {name: "name", label: strings.name, type: "text", placeholder: "Tropical Adventure" },
    {name: "placeTo", label: strings.placeTo, type: "text", placeholder: "Spain" },
    {name: "dateFrom", label: strings.dateFrom, type: "date", placeholder: "01/01/2025" },
    {name: "dateTo", label: strings.dateTo, type: "date", placeholder: "01/04/2025" },
    {name: "price", label: strings.price, type: "number", placeholder: "10000" },
    {name: "discount", label: strings.discount, type: "number", placeholder: "1000" },
    {name: "totalSeats", label: strings.totalSeats, type: "number", placeholder: "40" },
  ];

  const renderFields = (fields, values, handleChange, errors, touched) =>
    fields.map(({ name, label, type, placeholder }) => (
      <Form.Group as={Col} md="6" controlId={`validationFormik_${name}`} key={name}>
        <Form.Label>{label}</Form.Label>
        {name === 'dateFrom' || name === 'dateTo' ? (
          <ReactDatePicker
            selected={values[name] ? new Date(values[name]) : null}
            onChange={(date) => handleChange({ target: { name, value: date } })}
            dateFormat="dd/MM/yyyy"
            className={`form-control ${touched[name] && errors[name] ? "is-invalid" : ""}`}
            wrapperClassName="w-100"
            placeholderText={placeholder}
          />
        ) : (
          <Form.Control
            type={type}
            name={name}
            value={values[name]}
            onChange={handleChange}
            isValid={touched[name] && !errors[name]}
            isInvalid={touched[name] && !!errors[name]}
            placeholder={placeholder}
          />
        )}
        <Form.Control.Feedback type="invalid">{errors[name]}</Form.Control.Feedback>
      </Form.Group>
    ));

  return (
    <Modal show={props.showModal} onHide={props.handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{props.selectedExcursionForEdit?.id ? strings.updateExcursion : strings.addExcursion}</Modal.Title>
      </Modal.Header>
      <Formik
        validationSchema={schema}
        onSubmit={onFormSubmit}
        initialValues={{
          name: props.selectedExcursionForEdit?.name || '',
          placeTo: props.selectedExcursionForEdit?.placeTo || '',
          dateFrom: props.selectedExcursionForEdit?.dateFrom ? convertToISODate(props.selectedExcursionForEdit.dateFrom) : '',
          dateTo: props.selectedExcursionForEdit?.dateTo ? convertToISODate(props.selectedExcursionForEdit.dateTo) : '',
          price: props.selectedExcursionForEdit?.price || '',
          discount: props.selectedExcursionForEdit?.discount || '',
          totalSeats: props.selectedExcursionForEdit?.totalSeats || '',
        }}
      >
        {({handleSubmit, handleChange, values, touched, errors}) => (
          <Form noValidate onSubmit={handleSubmit}>
            <ModalBody>
              <Row className="mb-3">
                {renderFields(fields, values, handleChange, errors, touched)}
              </Row>
            </ModalBody>
            <ModalFooter>
              <button type="submit" className="btn btn-primary">{strings.submit}</button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default AddEditExcursionModal;